import {useState} from "react";

import {useGetMyApplicationsListQuery} from "../../application/api/get_my_applications_list";
import {IUnlockChoiceData} from "../types/IUnlockChoiceData";
import {markUnlockChoicePriceNegotiationShownInSession, wasUnlockChoicePriceNegotiationShownInSession} from "../utils/unlock_choice_price_negotiation_session";

interface IUseUnlockChoicePriceNegotiationParams {
    data: IUnlockChoiceData | null;
    offerId: number | null;
}

interface IUnlockChoicePriceNegotiationResult {
    isEligible: boolean;
    markShown: () => void;
    markDismissed: () => void;
}

export const useUnlockChoicePriceNegotiation = ({data, offerId}: IUseUnlockChoicePriceNegotiationParams): IUnlockChoicePriceNegotiationResult => {
    const [wasShownBefore] = useState(wasUnlockChoicePriceNegotiationShownInSession);
    const [isShown, setIsShown] = useState(false);
    const canBeShown = Boolean(data?.isPriceNegotiationAvailable) && offerId !== null && !wasShownBefore && !isShown;

    const {
        data: sentApplications,
        isFetching,
        isError
    } = useGetMyApplicationsListQuery(undefined, {
        skip: !canBeShown,
        refetchOnMountOrArgChange: true
    });

    const isSentApplicationsReady = sentApplications !== undefined && !isFetching && !isError;
    const hasAskedAboutOffer = isSentApplicationsReady && sentApplications.some((application) => application.offer === offerId);

    const markShown = () => {
        setIsShown(true);
    };

    const markDismissed = () => {
        markUnlockChoicePriceNegotiationShownInSession();
    };

    return {
        isEligible: canBeShown && isSentApplicationsReady && !hasAskedAboutOffer,
        markShown,
        markDismissed
    };
};
import {useState} from "react";

import {useGetMyApplicationsListQuery} from "../../application/api/get_my_applications_list";
import {IUnlockChoiceData} from "../types/IUnlockChoiceData";
import {markUnlockChoicePriceNegotiationShownInSession, wasUnlockChoicePriceNegotiationShownInSession} from "../utils/unlock_choice_price_negotiation_session";

interface IUseUnlockChoicePriceNegotiationParams {
    data: IUnlockChoiceData | null;
    offerId: number | null;
}

interface IUnlockChoicePriceNegotiationResult {
    isEligible: boolean;
    markShown: () => void;
    markDismissed: () => void;
}

export const useUnlockChoicePriceNegotiation = ({data, offerId}: IUseUnlockChoicePriceNegotiationParams): IUnlockChoicePriceNegotiationResult => {
    const [wasShownBefore] = useState(wasUnlockChoicePriceNegotiationShownInSession);
    const [isShown, setIsShown] = useState(false);
    const canBeShown = Boolean(data?.isPriceNegotiationAvailable) && offerId !== null && !wasShownBefore && !isShown;

    const {
        data: sentApplications,
        isFetching,
        isError
    } = useGetMyApplicationsListQuery(undefined, {
        skip: !canBeShown,
        refetchOnMountOrArgChange: true
    });

    const isSentApplicationsReady = sentApplications !== undefined && !isFetching && !isError;
    const hasAskedAboutOffer = isSentApplicationsReady && sentApplications.some((application) => application.offer === offerId);

    const markShown = () => {
        setIsShown(true);
    };

    const markDismissed = () => {
        markUnlockChoicePriceNegotiationShownInSession();
    };

    return {
        isEligible: canBeShown && isSentApplicationsReady && !hasAskedAboutOffer,
        markShown,
        markDismissed
    };
};
